import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user dashboard data */
export const getCCDashboardStats = async ({ queryKey }: any) => {
  const { id } = queryKey[1];
  const res = await get(`/external-api/get_creator_video_stats/${id}`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetCCStats = (queryParams: any, onSuccess: any, onError: any) => {
  return useQuery(['cc-dashboard-stats', queryParams], getCCDashboardStats, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetCCStats;
